import { Alert, Box, FormControl, TextField } from "@mui/material";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import localize from "../../../common/localize";
import { useEffect, useState } from "react";

export default function PasswordChange({
  userModel,
  setUserModel,
  validPassword,
  setValidPassword,
}) {
  const [passwordConfirmed, setPasswordConfirmed] = useState(false);
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const passwordRegex =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{6,20}$/;

  const handleChangeConfirmPassword = (e) => {
    setPasswordConfirmation(e.target.value);
    setPasswordConfirmed(userModel?.Password === e.target.value);
  };

  const validatePassword = (password) => {
    if (password) {
      const match = password.match(passwordRegex);
      if (match && match.length > 0) {
        setValidPassword(true);
        return;
      }
    }
    setValidPassword(false);
  };

  const handleChange = (e) => {
    if (e.target.name === "Password") {
      validatePassword(e.target.value);
      setPasswordConfirmed(e.target.value === passwordConfirmation);
    }

    setUserModel &&
      setUserModel({
        ...userModel,
        [e.target.name]: e.target.value,
      });
  };

  useEffect(() => {
    setPasswordConfirmed(validPassword && passwordConfirmed);
  }, [validPassword]);

  return (
    <Box
      className="flex flex-col gap-4 my-2"
      sx={{ width: "300px", maxWidth: "100%" }}
    >
      <FormControl required fullWidth>
        <TextField
          required
          InputLabelProps={getInputLabelProps()}
          inputProps={{
            ...getInputProps(),
            maxLength: 20,
          }}
          type="password"
          size="small"
          fullWidth
          id="currentPassword"
          name="currentPassword"
          label={localize.current_password}
          variant="outlined"
          onChange={handleChange}
          value={userModel?.currentPassword}
        />
      </FormControl>

      <FormControl required fullWidth>
        <TextField
          required
          InputLabelProps={getInputLabelProps()}
          inputProps={{
            ...getInputProps(),
            maxLength: 20,
          }}
          type="password"
          size="small"
          fullWidth
          id="Password"
          name="Password"
          label={localize.new_password}
          variant="outlined"
          onChange={handleChange}
          value={userModel?.Password}
        />
      </FormControl>

      <FormControl required fullWidth>
        <TextField
          required
          InputLabelProps={getInputLabelProps()}
          inputProps={{
            ...getInputProps(),
            maxLength: 20,
          }}
          type="password"
          size="small"
          fullWidth
          id="ConfirmPassword"
          name="ConfirmPassword"
          label={localize.confirm_password}
          variant="outlined"
          onChange={handleChangeConfirmPassword}
          value={passwordConfirmation}
        />
      </FormControl>

      <div className="flex w-full">
        <Alert
          className="w-full"
          severity={validPassword && passwordConfirmed ? "success" : "error"}
        >
          <p className="text-xs">
            {!validPassword
              ? localize.password_restriction
              : passwordConfirmed
              ? localize.valid_password
              : localize.password_no_match}
          </p>
        </Alert>
      </div>
    </Box>
  );
}
